import { gql } from 'graphql-query-contracts';

export default gql(`
  query loginEmailExists($email: EmailAddress!) {
    loginEmailExists(email: $email)
    userLocaleByEmail(email: $email) {
     locale
    }
  }
`);